// export default CreateRdv;
import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import FormBootstrap from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  createManualAppointment,
  createUnavailableAppointment,
  fetchCalendarData,
} from "../../store/slices/rendezVousPrestaSlice";
import {
  datewithTiret,
  formatDateToISO,
  formatTime,
  parseDateFromDDMMYYYY,
  parseDateTime,
} from "../../utils/utils.js";
import LocationAutocomplete from "../LocationAutocomplete.jsx";
import { useLoadScript } from "@react-google-maps/api";
import { parse } from "date-fns";

function CreateRdv({ handleClose, show, startdte, enddte, ...props }) {
  const libraries = ["places"];
  const [indisponible, setIndisponible] = useState(false);
  const [lieuSelectionne, setLieuSelectionne] = useState("");
  const { allEtablissementEquipes } = useSelector((state) => state.rdvPresta);
  const dispatch = useDispatch();
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Champ obligatoire"),
    date: Yup.string()
      .required("Champ requis")
      .test(
        "is-today-or-future",
        "La date ne peut pas être dans le passé",
        function (value) {
          if (!value) return false;
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const selected = parseDateFromDDMMYYYY(value);
          selected.setHours(0, 0, 0, 0);
          return selected >= today;
        }
      ),

    start_time: Yup.string()
      .required("Champ obligatoire")
      .test(
        "start-time-not-in-past",
        "L'heure de début ne peut pas être dans le passé",
        function (value) {
          const { date } = this.parent;
          if (!date || !value) return true;

          const today = new Date();
          const selectedDate = parseDateFromDDMMYYYY(date);

          if (selectedDate.toDateString() === today.toDateString()) {
            const [hours, minutes] = value.split(":").map(Number);
            const selectedStartTime = new Date(selectedDate);
            selectedStartTime.setHours(hours, minutes, 0, 0);
            return selectedStartTime > today;
          }
          return true;
        }
      ),

    end_time: Yup.string()
      .required("Champ obligatoire")
      .test(
        "is-after-start",
        "L'heure de fin doit être supérieure à l'heure de début",
        function (value) {
          const { start_time } = this.parent;
          if (!start_time || !value) return true;

          const [startH, startM] = start_time.split(":").map(Number);
          const [endH, endM] = value.split(":").map(Number);
          const start = new Date();
          start.setHours(startH, startM, 0, 0);
          const end = new Date();
          end.setHours(endH, endM, 0, 0);
          return end > start;
        }
      ),
    // equipe_id: Yup.string().required("Champ obligatoire"),
    equipe_id: Yup.string().test(
      "required-if-teams-exist",
      "Champ obligatoire",
      function (value) {
        console.log(
          "this.parent.allEtablissementEquipes",
          this.parent.allEtablissementEquipes
        );
        const teams = this.parent.allEtablissementEquipes; // <-- ici
        if (Array.isArray(teams) && teams.length > 0) {
          return Boolean(value && value.trim() !== "");
        }
        return true;
      }
    ),

    indisponible: Yup.bool(),
    last_name: Yup.string().when("indisponible", {
      is: false,
      then: (schema) => schema.required("Champ obligatoire"),
      otherwise: (schema) => schema.notRequired(),
    }),
    first_name: Yup.string().when("indisponible", {
      is: false,
      then: (schema) => schema.required("Champ obligatoire"),
      otherwise: (schema) => schema.notRequired(),
    }),
    // email: Yup.string()
    //   .email("Email invalide")
    //   .when("indisponible", {
    //     is: false,
    //     then: (schema) => schema.required("Champ obligatoire"),
    //     otherwise: (schema) => schema.notRequired(),
    //   }),
    // phone: Yup.string().when("indisponible", {
    //   is: false,
    //   then: (schema) => schema.required("Champ obligatoire"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    lieu_intervention: Yup.string().when("indisponible", {
      is: false,
      then: (schema) => schema.required("Champ obligatoire"),
      otherwise: (schema) => schema.notRequired(),
    }),
    meeting_link: Yup.string().when(["indisponible", "lieu_intervention"], {
      is: (indisponible, lieu_intervention) =>
        !indisponible && lieu_intervention === "enligne",
      then: (schema) => schema.required("Lien requis").url("Lien invalide"),
      otherwise: (schema) => schema.notRequired(),
    }),
    adresse_domicile: Yup.string().when(["indisponible", "lieu_intervention"], {
      is: (indisponible, lieu_intervention) =>
        !indisponible && lieu_intervention === "onsite",
      then: (schema) => schema.required("Champ obligatoire"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
  const formikRef = useRef(null);
  // console.log("props!!", props);
  const addMinutes = (date, minutes) =>
    new Date(new Date(date).getTime() + minutes * 60000);

  const handleLocationSelect = (
    place,
    setFieldValue,
    setFieldTouched,
    fieldName
  ) => {
    const address = place?.description || "";
    setFieldValue(fieldName, address);
    setFieldTouched(fieldName, true, false);
  };

  const initialValues = {
    title: "",
    date: formatDateToISO(startdte) || "",
    start_time: formatTime(startdte) || "",
    // end_time: formatTime(addMinutes(enddte, 30)) || "",
    end_time: formatTime(enddte, 30) || "",
    equipe_id: "",
    indisponible: false,
    last_name: "",
    first_name: "",
    email: "",
    phone: "",
    adresse_domicile: "",
    lieu_intervention: "",
    meeting_link: "",
    allEtablissementEquipes: allEtablissementEquipes,
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const start_time = `${values?.date} ${values?.start_time}:00`;
      const end_time = `${values?.date} ${values?.end_time}:00`;
      const payload = {
        ...values,
        start_time,
        end_time,
      };
      delete payload.date;
      if (values.indisponible) {
        await dispatch(createUnavailableAppointment(payload)).unwrap();
        toast.success("L'indisponibilité ajouté avec succès");
      } else {
        await dispatch(createManualAppointment(payload)).unwrap();
        toast.success("Rendez-vous créé avec succès ");
      }
      handleClose();
    } catch (error) {
      toast.error(error?.data?.message);
      setSubmitting(false);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      className="agenda"
      {...props}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="agendaTiltle">
          Créer un rendez-vous
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="form-container">
        <Formik
          innerRef={formikRef}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          context={{ allEtablissementEquipes }}
        >
          {({ values, setFieldValue, setFieldTouched, touched, errors }) => (
            <Form className="m-24">
              <FormBootstrap.Group className="mb-3">
                <FormBootstrap.Label className="legend">
                  Titre du rendez-vous*
                </FormBootstrap.Label>
                <Field name="title" className="form-control input" />
                <ErrorMessage
                  name="title"
                  className="text-danger"
                  component="div"
                />
              </FormBootstrap.Group>

              <div className="d-flex">
                <FormBootstrap.Group className="mb-3 w-30 m-4-right">
                  <FormBootstrap.Label className="legend">
                    Date*
                  </FormBootstrap.Label>
                  <Field
                    name="date"
                    className="form-control input"
                    type="date"
                  />
                  <ErrorMessage
                    name="date"
                    className="text-danger"
                    component="div"
                  />
                </FormBootstrap.Group>

                <FormBootstrap.Group className="mb-3 w-30 m-4-right">
                  <FormBootstrap.Label className="legend">
                    De*
                  </FormBootstrap.Label>
                  <Field
                    name="start_time"
                    className="form-control input"
                    type="time"
                  />
                  <ErrorMessage
                    name="start_time"
                    className="text-danger"
                    component="div"
                  />
                </FormBootstrap.Group>

                <FormBootstrap.Group className="mb-3 w-30 ">
                  <FormBootstrap.Label className="legend">
                    À*
                  </FormBootstrap.Label>
                  <Field
                    name="end_time"
                    className="form-control input"
                    type="time"
                  />
                  <ErrorMessage
                    name="end_time"
                    className="text-danger"
                    component="div"
                  />
                </FormBootstrap.Group>
              </div>
              {allEtablissementEquipes.length > 0 ? (
              <FormBootstrap.Group className="mb-3">
                <FormBootstrap.Label className="legend">
                  Salarié *
                </FormBootstrap.Label>
                <Field
                  as="select"
                  name="equipe_id"
                  className="form-control input"
                >
                  <option value="">Choisir un salarié</option>
                  {allEtablissementEquipes?.map((employee) => (
                    <option key={employee.id} value={employee.id}>
                      {employee.name}
                    </option>
                  ))}
                </Field>
                <ErrorMessage
                  name="equipe_id"
                  className="text-danger"
                  component="div"
                />
              </FormBootstrap.Group>
              ): ''}

              <FormBootstrap.Group className="mb-3">
                <FormBootstrap.Check
                  type="checkbox"
                  label="Non disponible sur ces horaires"
                  className="input legend"
                  checked={values.indisponible}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setFieldValue("indisponible", checked);
                    setIndisponible(checked);
                  }}
                />
              </FormBootstrap.Group>

              {!values.indisponible && (
                <>
                  <FormBootstrap.Group className="mb-3">
                    <FormBootstrap.Label className="legend">
                      Nom du client*
                    </FormBootstrap.Label>
                    <Field name="last_name" className="form-control input" />
                    <ErrorMessage
                      name="last_name"
                      className="text-danger"
                      component="div"
                    />
                  </FormBootstrap.Group>

                  <FormBootstrap.Group className="mb-3">
                    <FormBootstrap.Label className="legend">
                      Prénom du client*
                    </FormBootstrap.Label>
                    <Field name="first_name" className="form-control input" />
                    <ErrorMessage
                      name="first_name"
                      className="text-danger"
                      component="div"
                    />
                  </FormBootstrap.Group>

                  <FormBootstrap.Group className="mb-3">
                    <FormBootstrap.Label className="legend">
                      Email du client
                    </FormBootstrap.Label>
                    <Field
                      name="email"
                      type="email"
                      className="form-control input"
                    />
                    <ErrorMessage
                      name="email"
                      className="text-danger"
                      component="div"
                    />
                  </FormBootstrap.Group>

                  <FormBootstrap.Group className="mb-3">
                    <FormBootstrap.Label className="legend">
                      Téléphone du client
                    </FormBootstrap.Label>
                    <Field name="phone" className="form-control input" />
                    <ErrorMessage
                      name="phone"
                      className="text-danger"
                      component="div"
                    />
                  </FormBootstrap.Group>

                  <FormBootstrap.Group className="mb-3">
                    <FormBootstrap.Label className="legend">
                      Lieu d’intervention*
                    </FormBootstrap.Label>
                    <Field
                      as="select"
                      name="lieu_intervention"
                      className="form-control input"
                      value={values.lieu_intervention}
                      onChange={(e) => {
                        const selected = e.target.value;
                        setLieuSelectionne(selected);
                        setFieldValue("lieu_intervention", selected);
                      }}
                    >
                      <option value="" disabled selected>
                        Sélectionnez un lieu d'intervention
                      </option>
                      <option value="chezpro">Chez le professionnel</option>
                      <option value="onsite">À domicile</option>
                      <option value="enligne">En ligne</option>
                    </Field>
                    <ErrorMessage
                      name="lieu_intervention"
                      className="text-danger"
                      component="div"
                    />
                  </FormBootstrap.Group>

                  {lieuSelectionne === "enligne" && (
                    <FormBootstrap.Group className="mb-3">
                      <FormBootstrap.Label className="legend">
                        Lien de la visioconférence*
                      </FormBootstrap.Label>
                      <Field
                        as={FormBootstrap.Control}
                        type="url"
                        name="meeting_link"
                        className="form-control input"
                        isInvalid={
                          touched.meeting_link && !!errors.meeting_link
                        }
                      />
                      <FormBootstrap.Control.Feedback type="invalid">
                        {errors.meeting_link}
                      </FormBootstrap.Control.Feedback>
                    </FormBootstrap.Group>
                  )}

                  {lieuSelectionne === "onsite" && (
                    <div className="input-wrapper form-group mt-16">
                      <label className="form-label">Adresse du client*</label>
                      <div className="relative">
                        <LocationAutocomplete
                          onLocationSelect={(place) =>
                            handleLocationSelect(
                              place,
                              setFieldValue,
                              setFieldTouched,
                              "adresse_domicile"
                            )
                          }
                          isGoogleLoaded={isLoaded}
                          value={values.adresse_domicile}
                        />
                      </div>
                      <ErrorMessage
                        name="adresse_domicile"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                  )}
                </>
              )}
            </Form>
          )}
        </Formik>
      </Offcanvas.Body>
      <div className="offcanvas-footer mb-24">
        <div className="container plr24">
          <div className="mt-4 w-30">
            <Button
              onClick={() => {
                if (formikRef.current) {
                  formikRef?.current?.submitForm();
                }
              }}
              type="submit"
              variant="primary"
              className="twyny-cta-primary padding-submit width-100"
            >
              Créer le rendez-vous
            </Button>
          </div>

          <div className="mt-4 w-30 mt-8">
            <Button
              variant="secondary"
              onClick={handleClose}
              className="twyny-cta-secondary padding-submit width-100"
            >
              Annuler
            </Button>
          </div>
        </div>
      </div>
    </Offcanvas>
  );
}

export default CreateRdv;
